import storage from '@/shared/storage'
import { RouteLocationNormalized } from 'vue-router'
import { Common } from '@/interface/common.interface'

interface State {
  serverYear: number
  sidebarCollapsed: boolean
  loading: boolean
  crumbs: Array<Common.Crumb>
  lastRouter: RouteLocationNormalized | null
  isSidebarRoute: boolean
}

// 需要拿到公司名
const user = storage.get('user')
export default {
  state: {
    serverYear: undefined,
    sidebarCollapsed: true,
    loading: false,
    crumbs: [{ title: user?.orgName || '' }],
    lastRouter: null,
    isSidebarRoute: false,
  },
  mutations: {
    setSidebarCollapsed(state: State, sidebarCollapsed: boolean) {
      state.sidebarCollapsed = sidebarCollapsed
    },
    setCrumbs(state: State, crumbs: Array<Common.Crumb>) {
      state.crumbs = crumbs
    },
    addCrumb(state: State, crumb: Common.Crumb) {
      state.crumbs.push(crumb)
    },
    setIsSidebarRoute(state: State, isSidebarRoute: boolean) {
      state.isSidebarRoute = isSidebarRoute
    },
    setLoading(state: State, loading: boolean) {
      state.loading = loading
    },
    setLastRouter(state: State, lastRouter: RouteLocationNormalized) {
      state.lastRouter = lastRouter
    },
    setServerYear(state: State, serverYear: number) {
      state.serverYear = serverYear
    },
  },
  getters: {
    lastRouter: (state: State) => state.lastRouter,
  },
  actions: {},
}
